import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import {
  Switch,
  Route,
  useRouteMatch,
  useHistory,
} from 'react-router-dom';
import styles from './styles.module.scss';

// Make sure to bind modal to your appElement (http://reactcommunity.org/react-modal/accessibility/)
if (process.env.NODE_ENV !== 'test') Modal.setAppElement('#root');

const ModalMessage = ({
                        message,
                        subPath = 'message',
                      }) => {
  const {path} = useRouteMatch();
  const history = useHistory();
  const routePath = (path === '/') ? '' : path;
  const contentDirection = 'rtl';

  const closeModal = () => {
    history.goBack();
  };

  return (
    <>
      <Switch>
        <Route path={`${routePath}/${subPath}`}>
          <Modal
            isOpen={true}
            onRequestClose={closeModal}
            className={`${styles.modal} ${styles[contentDirection]}`}
            overlayClassName={`${styles.overlay}`}
          >
            <div dir={contentDirection} className={`${styles.modalContainer}`}>
              <div className={styles.content}>
                <div className={styles.text}>
                  {message}
                </div>
                <button className={styles.button} onClick={closeModal}>
                  סגירה
                </button>
              </div>
            </div>
          </Modal>
        </Route>
      </Switch>
    </>
  );
};

ModalMessage.propTypes = {
  message: PropTypes.string,
  subPath: PropTypes.string,
};

export default ModalMessage;
